import { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCart } from "../../redux";

import { useFormatText } from "../../hooks/useFormatText";
import { LangContext } from "../../context/LangContext";
import { useGoPage } from "../../hooks/useGoPage";

import Cart from "./Cart";
import ChoosePayment from "./ChoosePayment";
import StripeCheckout from "./StripeCheckout";

import "./style.css"

function ModalShop({ modal, setModal }) {
    const goPage = useGoPage();
    const dispatch = useDispatch();
    const formatText = useFormatText();

    const cart = useSelector(state => state.cart);
    const { translations } = useContext(LangContext);

    const [customerInfo, setCustomerInfo] = useState({
        firstname: '',
        lastname: '',
        email: '',
        address: '',
        city: '',
        country: '',
        zip_code: ''
    });

    const closeMdl = () => {
        if (modal === "success") {
            dispatch(setCart([]));
            goPage('shop');
        }
        setModal(null);
    }

    return (
        <div className="modal_cart_or_checkout">
            <button
                className="close_mdl"
                onClick={() => closeMdl()}
            ></button>

            {modal === "cart" && <Cart setModal={setModal} />}
            {modal === "choose" && <ChoosePayment setModal={setModal} cart={cart} customerInfo={customerInfo} setCustomerInfo={setCustomerInfo} />}
            {modal === "stripe" && <StripeCheckout setModal={setModal} cart={cart} customerInfo={customerInfo} />}

            {modal === "success" &&
                <div className="content mdl_success">
                    <span className="title_mdl">{translations.order_received}</span>
                    <p className="descrip">{formatText(translations.your_order_has_been_received)}</p>

                    <div className="panel_modal">
                        <button
                            className="btn_close"
                            onClick={() => closeMdl()}
                        >{translations.close}</button>
                    </div>
                </div>
            }
        </div>
    )
}

export default ModalShop;